import React from "react";
import ReactQueryParams from "react-query-params";
import apiProxy from "../../api/apiProxy.js";
import defaultSensorId from "../../model/devices/defaultSensorId";
import { compose, setDisplayName } from "recompose";
import LoadingWrapper from "../LoadingWrapper";
import PageTitle from "../PageTitle";
import NotFoundView from "../NotFoundView";
import storeProxy from "../../api/proxies/storeProxy.js";

const DeviceDetailsPageWrapper = WrappedComponent => {
  return class extends ReactQueryParams {
    state = {
      device: {},
      isLoading: true,
      isEnergySubmeter: true
    };

    componentDidMount() {
      this.loadDevice();
    }

    handleSensorChange = newSensorId => {
      this.setQueryParams({
        sensorId: newSensorId
      });
    };

    loadDevice() {
      this.setState({ isLoading: true });
      let fetchDeviceResponse = {};

      const deviceId = this.props.deviceId;

      apiProxy.device
        .getDevice(deviceId)
        .then(response => {
          fetchDeviceResponse = response;

          return storeProxy.getLatestSensorDataForStore(response.store.storeId);
        })
        .then(response => {
          const device = fetchDeviceResponse;
          const lastestSensorData = response.data;
          if (device.deviceType !== "EnergySubMeter") {
            this.setState({ isEnergySubmeter: false });
          } else {
            this.setState({
              device: this.mapDevice(device, lastestSensorData),
              isLoading: false
            });
          }
        })
        .catch(response => {
          this.props.onError(response);
        });
    }

    mapDevice = (device, latestSensorData) => {
      const mappedSensors = device.sensors.map(s => {
        let sensor = null;

        const sensorId = s.dingoId.split("-")[1];

        const sensorData = latestSensorData.find(
          sd => sd.sensorId === sensorId
        );

        let latestSensorDataForSensor = null;

        if (sensorData) {
          latestSensorDataForSensor = {
            time: sensorData.data.values[0][0],
            value: sensorData.data.values[0][1]
          };
        }

        sensor = {
          ...s,
          latestSensorData: latestSensorDataForSensor
        };
        return sensor;
      });

      return {
        ...device,
        sensors: mappedSensors
      };
    };

    currentSensor() {
      return this.state.energyChart.data.sensors[0].sensor;
    }

    sensorId() {
      return (
        this.queryParams.sensorId || defaultSensorId(this.state.device.sensors)
      );
    }

    render() {
      if (!this.state.isEnergySubmeter) {
        return <NotFoundView />;
      }
      return (
        <PageTitle title={this.state.device.name}>
          <LoadingWrapper isLoading={this.state.isLoading}>
            <WrappedComponent
              device={this.state.device}
              sensorId={this.sensorId()}
              onSensorChange={this.handleSensorChange}
            />
          </LoadingWrapper>
        </PageTitle>
      );
    }
  };
};

export default compose(
  setDisplayName("DeviceDetailsPageWrapper"),
  DeviceDetailsPageWrapper
);
